import React from "react";
import { COMPANY_DATA } from "../../constant/CompanyData";
import { JOB_LIST } from "../../constant/Careers";
import { FaMapMarkerAlt, FaBriefcase, FaLaptop } from "react-icons/fa";
import Eyebrow from "../common/Eyebrow";

const Careers = () => {
  return (
    <div className="bg-slate-50 py-20">
      <div className="mx-auto mb-14 max-w-3xl px-6 text-center">
        <Eyebrow>Careers</Eyebrow>
        <h1 className="mt-3 text-4xl font-bold tracking-tight text-[var(--website-primary-color)] md:text-5xl">Build the infrastructure behind ambitious teams.</h1>
        <p className="mt-5 leading-relaxed text-slate-600">
          Join our growing team of talented professionals!
        </p>
      </div>

      <section className="mx-auto max-w-6xl px-6">
        <h2 className="text-center text-2xl font-bold text-[var(--website-primary-color)] md:text-3xl">
          Available Positions
        </h2>

        <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {JOB_LIST.map((position, index) => (
            <div
              key={index}
              className="flex flex-col justify-between rounded-2xl border border-slate-200 bg-white p-7 shadow-sm transition duration-300 hover:-translate-y-1 hover:border-[rgba(var(--website-secondary-rgb),0.6)] hover:shadow-lg"
            >
              <div>
                <h3 className="text-xl font-semibold text-[var(--website-primary-color)]">
                  {position.title}
                </h3>
                <p className="mt-3 leading-relaxed text-slate-600">{position.description}</p>
                <div className="mt-5 flex items-center text-sm text-slate-500">
                  <FaMapMarkerAlt className="mr-2 text-[var(--website-secondary-color)]" />
                  {position.location}
                </div>
                <div className="mt-2 flex items-center text-sm text-slate-500">
                  <FaBriefcase className="mr-2 text-[var(--website-secondary-color)]" />
                  {position.jobType}
                </div>
                <div className="mt-2 flex items-center text-sm text-slate-500">
                  <FaLaptop className="mr-2 text-[var(--website-secondary-color)]" />
                  {position.workMode}
                </div>
              </div>
              <div className="pt-7">
                <a
                  href={COMPANY_DATA.careerFormLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block"
                >
                  <span className="inline-flex rounded-full bg-[var(--website-secondary-color)] px-5 py-3 text-sm font-semibold text-[var(--on-secondary)] transition hover:brightness-110">
                    Apply Now
                  </span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Careers;
